import { Box, Button, Modal, TextField, Typography } from "@mui/material";
import { useEffect } from "react";
import { Controller, useForm } from "react-hook-form";
import { useTipos } from "../../../../context/SuperAdmin/OASContexts/TiposContext";
import { TipoFields } from "../../../../interfaces/SuperAdmin/Pages/iDataTipos";

const EditTiposModal = () => {
  const {
    isEditTipoModalOpen,
    toggleEditTipoModal,
    toEditTipo,
    tipoEdit,
    isEditingTipo,
  } = useTipos();

  const {
    control,
    formState: { errors },
    handleSubmit,
    reset,
  } = useForm<TipoFields>();

  // Función para manejar el envío del formulario
  const handleSubmitForm = (data: TipoFields) => {
    if (toEditTipo) {
      tipoEdit(data, toEditTipo.id_tipo);
    }
  };

  const handleClose = () => {
    if (!isEditingTipo) {
      reset();
      toggleEditTipoModal(false);
    }
  };

  useEffect(() => {
    if (toEditTipo) {
      reset({
        nombre: toEditTipo.nombre,
      });
    }
  }, [toEditTipo]);

  return (
    <Modal
      open={isEditTipoModalOpen}
      onClose={handleClose}
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        bgcolor: "rgba(0, 0, 0, 0.3)", // Fondo negro con opacidad
      }}
    >
      <Box
        component="form"
        sx={{
          width: 400,
          bgcolor: "background.paper", // Fondo blanco del modal
          borderRadius: 2, // Bordes redondeados
          p: 4,
          boxShadow: 24,
          minWidth: "600px",
          display: "flex",
          flexDirection: "column",
          gap: 3,
        }}
        onSubmit={handleSubmit(handleSubmitForm)}
      >
        <Typography variant="h6" component="h2">
          Editar tipo
        </Typography>

        {/* Campo Nombre */}
        <Box sx={{ display: "flex", flexDirection: "column" }}>
          <Typography variant="body1" sx={{ fontWeight: 500 }}>
            Nombre
          </Typography>
          <Controller
            name="nombre"
            control={control}
            rules={{ required: "El nombre es obligatorio" }}
            render={({ field }) => (
              <TextField
                {...field}
                fullWidth
                margin="normal"
                error={!!errors.nombre}
                helperText={errors.nombre?.message}
                disabled={isEditingTipo}
                multiline
                minRows={3}
                maxRows={8}
              />
            )}
          />
        </Box>

        <Box sx={{ mt: 3, textAlign: "right" }}>
          <Button
            variant="contained"
            sx={{ background: "#336B87" }}
            disabled={isEditingTipo}
            type="submit"
          >
            {isEditingTipo ? "Guardando" : "Guardar"}
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default EditTiposModal;
